export default __webpack_public_path__ + "static/media/014-refrigerator.47623325.svg";